<template>
  <div
    class="indicator-status"
    :class="activeStatus"
  ></div>
</template>

<script>
export default {
    name: 'IndicatorStatus',
    props: {
      isActiveStatus: {
        type: Boolean,
        required: true,
      }
    },
    computed: {
      activeStatus() {
        return {
          'indicator-status_active': this.isActiveStatus,
          'indicator-status_inactive': !this.isActiveStatus,
        }
      }
    }
}
</script>

<style>
.indicator-status {
  width: 16px;
  height: 16px;
  border-radius: 15px;
  margin: 0 auto;
}

.indicator-status_active {
  background-color: #42DDA1;
}

.indicator-status_inactive {
  background-color: #DD4242;
}

</style>